// @flow
import { takeEvery, put, call } from 'redux-saga/effects';

import { getResource } from '@redux/components/ApiRequest/actions';
import { changeTitle } from '@redux/components/Metadata/actions';
import { pageReady } from '@redux/components/Page/actions';

import { mainApiUrl } from '@lib';

import { TREATMENT_DETAILS_REQUEST, TREATMENT_DETAILS_UPDATE } from './constants';
import { updateTreatmentDetails, errorTreatmentDetails } from './actions';

import type { Action } from '../types';

export function* treatmentDetailsRequestFlow({ slug }: Action): Generator<Function, void, void> {
  if (!slug) return;

  const url: string = `${mainApiUrl}/v1/treatments/${slug}`;
  yield put(getResource(url, updateTreatmentDetails, errorTreatmentDetails));
}

export function* treatmentDetailsUpdateFlow(action: Action): Generator<Function, void, void> {
  const title: ?string = action?.data?.attributes?.tagline;

  yield put(changeTitle({ IN: { en: title } }));
  yield put(pageReady());
}

export function* treatmentDetailsFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case TREATMENT_DETAILS_REQUEST:
      yield call(treatmentDetailsRequestFlow, action);
      break;
    case TREATMENT_DETAILS_UPDATE:
      yield call(treatmentDetailsUpdateFlow, action);
      break;
    default:
      break;
  }
}

export default function* jobDetailsWatcher(): Generator<Function, void, Action> {
  yield takeEvery([TREATMENT_DETAILS_REQUEST, TREATMENT_DETAILS_UPDATE], treatmentDetailsFlow);
}
